import styled from 'styled-components';

export const H1 = styled.h1`
    font-size: ${({ theme }) => theme.fontSizes[7]};
    color: ${({ theme }) => theme.colors.fontPrimary};
    font-weight: normal;
    letter-spacing: -0.016rem;
`;

export const H2 = styled.h2`
    font-size: ${({ theme }) => theme.fontSizes[6]};
    color: ${({ theme }) => theme.colors.fontPrimary};
    font-weight: normal;
    letter-spacing: -0.015rem;
`;

export const H3 = styled.h3`
    font-size: ${({ theme }) => theme.fontSizes[5]};
    color: ${({ theme }) => theme.colors.fontPrimary};
    font-weight: normal;
    letter-spacing: -0.0125rem;
`;
